import { debounce } from 'lodash-es';
import { closeIdeoToast, showIdeoToast } from '../components/ideo/ui-toast/service';
import type { IdeoToastId, IdeoToastOptions, IdeoToastVariant } from '../components/ideo/ui-toast/types';

const DEBOUNCE_TIME = 1000;
const DEBOUNCE_DEFAULT_OPTIONS = { leading: true, trailing: false };

class MessagesHelper implements Alerts
{
    public close(id?: IdeoToastId)
    {
        closeIdeoToast(id);
    }

    public message(message: string, options: IdeoToastOptions = {})
    {
        return this.show('default', message, options);
    }

    public loading(message: string, options: IdeoToastOptions = {})
    {
        return this.show('loading', message, options);
    }

    public success(message: string, options: IdeoToastOptions = {})
    {
        return this.show('success', message, options);
    }

    public debounceSuccess = debounce((message: string, options: IdeoToastOptions = {}) =>
    {
        this.success(message, options);
    },
    DEBOUNCE_TIME, DEBOUNCE_DEFAULT_OPTIONS);

    public info(message: string, options: IdeoToastOptions = {})
    {
        return this.show('info', message, options);
    }

    public debounceInfo = debounce((message: string, options: IdeoToastOptions = {}) =>
    {
        this.info(message, options);
    },
    DEBOUNCE_TIME, DEBOUNCE_DEFAULT_OPTIONS);

    public warning(message: string, options: IdeoToastOptions = {})
    {
        return this.show('warning', message, options);
    }

    public debounceWarning = debounce((message: string, options: IdeoToastOptions = {}) =>
    {
        this.warning(message, options);
    },
    DEBOUNCE_TIME, DEBOUNCE_DEFAULT_OPTIONS);

    public danger(message: string, options: IdeoToastOptions = {})
    {
        return this.show('error', message, options);
    }

    public debounceDanger = debounce((message: string, options: IdeoToastOptions = {}) =>
    {
        this.danger(message, options);
    },
    DEBOUNCE_TIME, DEBOUNCE_DEFAULT_OPTIONS);

    public error(message: string, options: IdeoToastOptions = {})
    {
        return this.show('error', message, options);
    }

    public debounceError = debounce((message: string, options: IdeoToastOptions = {}) =>
    {
        this.error(message, options);
    },
    DEBOUNCE_TIME, DEBOUNCE_DEFAULT_OPTIONS);

    private show(variant: IdeoToastVariant, message: string, options: IdeoToastOptions)
    {
        return showIdeoToast(variant, message, options);
    }
}

export default defineNuxtPlugin({
    name: 'alerts',
    dependsOn: [],
    setup()
    {
        return {
            provide: {
                alert: new MessagesHelper()
            }
        };
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        $alert: Alerts;
    }
}
